__turbopack_context__.v({
  "ariaSlider": "PlasmicSlider-module__BtbDaW__ariaSlider",
  "ariaSliderOutput": "PlasmicSlider-module__BtbDaW__ariaSliderOutput",
  "ariaSliderOutputfooterSlider_footerSlider": "PlasmicSlider-module__BtbDaW__ariaSliderOutputfooterSlider_footerSlider",
  "ariaSliderTrack": "PlasmicSlider-module__BtbDaW__ariaSliderTrack",
  "background": "PlasmicSlider-module__BtbDaW__background",
  "description": "PlasmicSlider-module__BtbDaW__description",
  "foreground": "PlasmicSlider-module__BtbDaW__foreground",
  "foregroundfooterSlider_footerSlider": "PlasmicSlider-module__BtbDaW__foregroundfooterSlider_footerSlider",
  "freeBox__qHq2": "PlasmicSlider-module__BtbDaW__freeBox__qHq2",
  "freeBox__vtce5": "PlasmicSlider-module__BtbDaW__freeBox__vtce5",
  "sliderThumb__tHBg": "PlasmicSlider-module__BtbDaW__sliderThumb__tHBg",
  "text___1IMmE": "PlasmicSlider-module__BtbDaW__text___1IMmE",
  "text__cZqao": "PlasmicSlider-module__BtbDaW__text__cZqao",
  "text__ta12Q": "PlasmicSlider-module__BtbDaW__text__ta12Q",
});
